import { ViewResolver } from '@Components/ViewResolver';
import { useAppSelector } from '@Hooks/index';

import {
  comparisonSheetOffersSelector,
  comparisonSheetSuppliersSelector,
} from '@Features/MaterialRequest/requests/MaterialRequisition/store/selectors/materialRequestSelector';
import { ComparisonSheetState } from '@Features/MaterialRequest/requests/components/ComparisonSheet/ComparisonSheet.types';
import { NoData } from '@Components/RequestList/noData';
import { useNavigate } from 'react-router-dom';
import { useFormikContext } from 'formik';
import MRFeatureRoutePath from '@Features/router/mr/MRFeatureRoutePath.enum';
import MaterialsTabDesktop from './desktop/MaterialsTabDesktop';
import MaterialsTabMobile from './mobile/MaterialsTabMobile';
import { MaterialVendorItem } from './types';

const MaterialsTab: React.FC = () => {
  const formik = useFormikContext<ComparisonSheetState>();
  const comparisonSheetOffers = useAppSelector(comparisonSheetOffersSelector);
  const comparisonSheetSuppliers = useAppSelector(
    comparisonSheetSuppliersSelector
  );
  const navigate = useNavigate();

  if (!comparisonSheetOffers || !comparisonSheetSuppliers) {
    return <NoData context="comparison-screen" />;
  }

  const handleSelectMaterial = (
    materialVendorItem: MaterialVendorItem
  ): void => {
    navigate('?materialView=true', { state: materialVendorItem });
  };

  const handleApprove = (): void => {
    navigate(MRFeatureRoutePath.COMPARISON_SHEET_SELECTED);
  };

  if (!formik.values.allOffers) return null;

  return (
    <ViewResolver
      desktop={
        <MaterialsTabDesktop
          comparisonSheetOffers={formik.values.allOffers}
          comparisonSheetSuppliers={comparisonSheetSuppliers}
        />
      }
      mobile={
        <MaterialsTabMobile
          comparisonSheetOffers={comparisonSheetOffers}
          comparisonSheetSuppliers={comparisonSheetSuppliers}
          formik={formik}
          handleSelectMaterial={handleSelectMaterial}
          handleReviewApprove={handleApprove}
        />
      }
    />
  );
};
export default MaterialsTab;
